import { Link } from 'react-router-dom';
import { Box } from '@givebutter/primitives/box';
import { maskWholeNumber, pluralize } from '@givebutter/util';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentEngageMessage } from 'customHooks/useCurrentEngageMessage';

const SuccessfullySent = () => {
    const { accountId } = useCurrentAccount();
    const { data: message } = useCurrentEngageMessage();

    return (
        <Box className="animate__animated animate__pulse animate__fast m-auto max-w-md rounded-lg p-16 text-center">
            <FontAwesomeIcon icon={faCheckCircle} className="mb-8 text-7xl text-green-600" />
            <div className="flex flex-col gap-4"></div>
            <p className="text-2xl font-medium">Success!</p>
            <p>
                {message.sending_at === null && <>We're now sending this message to</>}
                <br />
                {message.sending_at !== null && <>Message queued for sending to</>}{' '}
                <strong>
                    {maskWholeNumber(message.recipient_count)}{' '}
                    {pluralize(message.recipient_count, 'contact')}
                </strong>{' '}
                {message.recipient_excluded_count > 0 && (
                    <>({maskWholeNumber(message.recipient_excluded_count)} excluded)</>
                )}
            </p>
            <p>
                You can track analytics from{' '}
                <Link to={`/accounts/${accountId}/engage`}>Engage Home</Link>
            </p>
        </Box>
    );
};

export default SuccessfullySent;
